

import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores/usuarios/auth.store";




export const PublicRoute2 = ({ children }) => {


    const authStatus = useAuthStore(state => state.status);


    return authStatus === 'authorized'
        ? <Navigate to="/super" replace />
        : children;

}
